import request from '@/utils/request'
// 查询统计数据分页
export function convertCodeTotal(query) {
    return request({
        url: '/redeem-code/statistics/total',
        method: 'get',
        params: query
    })
}

export function convertCodeTotalDetail (query) {
    return request({
        url: '/video/convertcombo/getConvertDetailPage',
        method: 'get',
        params: query
    })
}
